import { ComponentType, Suspense, lazy, useEffect, useState } from "react";
import { scheduleIdle } from "@/lib/scheduleIdle";

type Loader = () => Promise<{ default: ComponentType }>;

interface DeferredCanvasProps {
  loader: Loader;
}

const DeferredCanvas = ({ loader }: DeferredCanvasProps) => {
  const [Lazy] = useState(() => lazy(loader));
  const [ready, setReady] = useState(false);

  useEffect(() => {
    scheduleIdle(() => setReady(true));
  }, []);

  if (!ready) return null;
  return (
    <Suspense fallback={null}>
      <Lazy />
    </Suspense>
  );
};

export default DeferredCanvas;
